import { ActionResult, namespace } from "../modules/tasks/tasks";
import { ApiPostTask, Task, ApiPatchTask } from "@/tasks";
import { Store } from "vuex";
import { TaskFilterOption } from "@/enums";
import storeHelper from "../../store/store-helper";

export class TasksStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the tasks */
    public get tasks(): Task[] {
        return this.store.getters[`${namespace}/tasks`];
    }

    /** Gets the filtered tasks */
    public get filteredTasks(): Task[] {
        return this.store.getters[`${namespace}/filteredTasks`];
    }

    /** Gets the selected filter */
    public get selectedFilter(): TaskFilterOption {
        return this.store.getters[`${namespace}/selectedFilter`];
    }

    /** Loads the tasks */
    public async loadTasksAsync(): Promise<void | null> {
        await this.store.dispatch(`${namespace}/loadTasksAsync`);
    }

    /**Update filtered tasks */
    public async updateFilteredTasks(tasks: Task[]) {
        this.store.dispatch(`${namespace}/updateFilteredTasks`, { tasks: tasks });
    }

    /**Update selected tasks filter */
    public async updateSelectedFilter(filter: TaskFilterOption) {
        this.store.dispatch(`${namespace}/updateSelectedFilter`, { filter: filter });
    }

    /** Update task read property */
    public async updateReadTasksAsync(tasks: Task[], forceUpdateRead: boolean = false): Promise<void> {
        let readMustBeUpdated = false;

        let taskIDsToUpdate = [];
        tasks.map(t => {
            let unreadNotifications = t.notifications ? t.notifications.filter(x => x.read == false) : [];
            if ((!t.read && forceUpdateRead) || (!t.read && unreadNotifications.length == 0)) {
                t.read = true; //to prevent the same task form being updated multiple times when click fast
                taskIDsToUpdate.push(t.id);
                readMustBeUpdated = true;
            }
        });

        if (readMustBeUpdated) {
            await Promise.all(
                taskIDsToUpdate.map(async t => {
                    await this.store.dispatch(`${namespace}/updateReadTasksAsync`, { task_id: t, isRead: true });
                })
            );

            storeHelper.userStore.updateUserStatistics();
        }
    }

    /** Update task is_important property */
    public async updateIsImportantTaskAsync(taskId: string, isImportant: boolean): Promise<void> {
        await this.store.dispatch(`${namespace}/updateIsImportantTaskAsync`, { task_id: taskId, is_important: isImportant });
    }

    /** Update task postponed_until_date property */
    public async updatePostponedUntilDateTaskAsync(taskId: string, newPostponedUntilDate: Date): Promise<void> {
        await this.store.dispatch(`${namespace}/updatePostponedUntilDateTaskAsync`, {
            task_id: taskId,
            postponedUntilDate: newPostponedUntilDate
        });
    }
}
